module.exports = __webpack_public_path__ + "img/stop-15.fba7e2ee.jpg";